import { AxiosResponse } from 'axios';
import api from '../../api';

const internalPath = '/trading/engine/';
class TradingService {
  getAllTrading() {
    return api.get(internalPath);
  }
  getTrading(id: string): Promise<AxiosResponse<any | null>> {
    return api.get<any>(`/internalPath/${id}`, {
      headers: { dashboard: true }
    });
  }
  deleteTrading(tradingID: string) {
    return api.delete<void>(`${internalPath}/${tradingID}`);
  }
  createTrading(trading: any) {
    return api.post<any>(internalPath, trading);
  }
  editTrading(trading: any) {
    return api.put<any>(internalPath, trading);
  }
}

export default new TradingService();
